export default __webpack_public_path__ + "static/media/MHAC.f051e520.png";